webpackJsonp([3],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return h; });
/* unused harmony export createElement */
/* unused harmony export cloneElement */
/* unused harmony export createRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return render; });
/* unused harmony export rerender */
/* unused harmony export options */
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

function applyRef(ref, value) {
  if (ref) {
    if (typeof ref == 'function') ref(value);else ref.current = value;
  }
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p;
	while (p = items.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		applyRef(old, null);
		applyRef(value, node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.shift()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null) applyRef(node['__preactattr_'].ref, null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	applyRef(component.__ref, component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.push(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] != null) applyRef(base['__preactattr_'].ref, null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	applyRef(component.__ref, null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

function createRef() {
	return {};
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	createRef: createRef,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* unused harmony default export */ var _unused_webpack_default_export = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_App__ = __webpack_require__(160);



// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var container = document.getElementById('js-shop-overview-app');

if (container) {
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__containers_App__["a" /* default */], null), container);
}

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_ProductsAPI__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_TableAPI__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Posts__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Filter__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Loader__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pagination__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_body_scroll_lock__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_body_scroll_lock__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.state = {
      isLoading: true,
      posts: [],
      allPosts: [],
      currentCategories: [],
      currentWidths: [],
      currentColors: [],
      allCategories: [],
      allWidths: [],
      allColors: [],
      count: 15,
      offset: 0,
      currentPage: 1,
      order: '',
      showAll: false
    };
    return _this;
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Pagination
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var currentPage = urlParams.get('current_page');

      if (currentPage) {
        this.setState({
          posts: [],
          allPosts: [],
          currentPage: Number(currentPage),
          offset: this.state.count * Number(currentPage) - this.state.count
        }, this.initiate);
      } else {
        this.initiate();
      }
    }
  }, {
    key: 'initiate',
    value: function initiate() {
      this.fetchProducts();
      this.fetchAllPosts();
    }
  }, {
    key: 'fetchProducts',
    value: function fetchProducts() {
      var _this2 = this;

      this.setState({ isLoading: true });

      __WEBPACK_IMPORTED_MODULE_1__api_ProductsAPI__["a" /* default */].all(this.state).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this2.setState({
          posts: [].concat(_toConsumableArray(_this2.state.posts), _toConsumableArray(data)),
          isLoading: false
        });
      }).catch(function (error) {
        _this2.setState({
          fetchError: true,
          isLoading: false
        });
        throw Error('Fetching products failed: ' + error);
      });
    }
  }, {
    key: 'fetchAllPosts',
    value: function fetchAllPosts() {
      var _this3 = this;

      this.setState({ isLoading: true });

      __WEBPACK_IMPORTED_MODULE_2__api_TableAPI__["a" /* default */].all(this.state).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this3.setState({
          allPosts: [].concat(_toConsumableArray(_this3.state.allPosts), _toConsumableArray(data)),
          isLoading: false
        }), _this3.fetchCategories(), _this3.fetchThickness(), _this3.fetchColors();
      }).catch(function (error) {
        _this3.setState({
          fetchError: true,
          isLoading: false
        });
        throw Error('Fetching products failed: ' + error);
      });
    }
  }, {
    key: 'fetchCategories',
    value: function fetchCategories() {
      var allCategoriesArray = [].concat(_toConsumableArray(this.state.allCategories));

      this.state.allPosts.map(function (post) {
        allCategoriesArray.includes(post.product_shape) || post.product_shape < 1 ? null : allCategoriesArray.push(post.product_shape);
      });

      this.setState(function () {
        return {
          allCategories: allCategoriesArray
        };
      });
    }
  }, {
    key: 'fetchThickness',
    value: function fetchThickness() {
      var allWidthsArray = [].concat(_toConsumableArray(this.state.allWidths));

      this.state.allPosts.map(function (post) {
        allWidthsArray.includes(post.product_thickness) || post.product_thickness < 1 ? null : allWidthsArray.push(post.product_thickness);
      });

      this.setState(function () {
        return {
          allWidths: allWidthsArray
        };
      });
    }
  }, {
    key: 'fetchColors',
    value: function fetchColors() {
      var allColorsArray = [].concat(_toConsumableArray(this.state.allColors));

      this.state.allPosts.map(function (post) {
        allColorsArray.includes(post.product_color) || post.product_color.length < 1 ? null : allColorsArray.push(post.product_color);
      });

      this.setState(function () {
        return {
          allColors: allColorsArray
        };
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      var currentElements = [].concat(_toConsumableArray(this.state[e.currentTarget.dataset.target]));

      currentElements.includes(e.currentTarget.dataset.id) ? currentElements = currentElements.filter(function (item) {
        return item !== e.currentTarget.dataset.id;
      }) : currentElements.push(e.currentTarget.dataset.id);

      this.setState(function () {
        var _ref;

        return _ref = {}, _defineProperty(_ref, e.currentTarget.dataset.target, currentElements), _defineProperty(_ref, 'posts', []), _defineProperty(_ref, 'allPosts', []), _defineProperty(_ref, 'offset', 0), _ref;
      }, this.initiate);
    }
  }, {
    key: 'handleRemove',
    value: function handleRemove(e) {
      var currentElements = [].concat(_toConsumableArray(this.state[e.currentTarget.dataset.target]));
      currentElements = currentElements.filter(function (item) {
        return item !== e.currentTarget.dataset.id;
      });

      this.setState(function () {
        var _ref2;

        return _ref2 = {}, _defineProperty(_ref2, e.currentTarget.dataset.target, currentElements), _defineProperty(_ref2, 'posts', []), _defineProperty(_ref2, 'allPosts', []), _defineProperty(_ref2, 'offset', 0), _ref2;
      }, this.initiate);
    }
  }, {
    key: 'handleReset',
    value: function handleReset() {
      this.setState(function () {
        return {
          posts: [],
          allPosts: [],
          allCategories: [],
          allWidths: [],
          allColors: [],
          currentCategories: [],
          currentWidths: [],
          currentColors: []
        };
      }, this.initiate);
    }
  }, {
    key: 'handleToggle',
    value: function handleToggle() {
      if (this.state.filterActive) {
        Object(__WEBPACK_IMPORTED_MODULE_7_body_scroll_lock__["clearAllBodyScrollLocks"])();
      }
      this.setState({ filterActive: !this.state.filterActive });
    }
  }, {
    key: 'updateURL',
    value: function updateURL(page) {
      // Update URL so page is set on refresh
      if (history.pushState) {
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + ('?current_page=' + page);
        window.history.pushState({ path: newurl }, '', newurl);
      }
    }
  }, {
    key: 'handlePageClick',
    value: function handlePageClick(e) {
      // Multiply the count by the currentPage to get the correct offset
      if (e.currentTarget.dataset.page) {
        window.scrollTo(0, 0);
        this.updateURL(e.currentTarget.dataset.page);
        this.setState({
          posts: [],
          allPosts: [],
          currentPage: Number(e.currentTarget.dataset.page),
          offset: this.state.count * Number(e.currentTarget.dataset.page) - this.state.count
        }, this.initiate);
      }
    }
  }, {
    key: 'handleOrderChoice',
    value: function handleOrderChoice(order) {
      this.setState({
        order: order.currentTarget.dataset.id,
        posts: [],
        allPosts: [],
        offset: 0
      }, this.fetchProducts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-shop-overview__app-container' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-shop-overview__filter-top-bar u-flex u-flex-sb' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { 'class': 'c-shop-overview__count' },
            this.state.allPosts.length,
            ' resultaten'
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { className: 'c-shop-overview__filter-button', onClick: this.handleToggle.bind(this) },
            'Filteren',
            this.state.filterActive ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'svg',
              { className: 'c-icon c-shop-overview__filter-icon active' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('use', { href: '#close', xlinkHref: '#close' })
            ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'svg',
              { className: 'c-icon c-shop-overview__filter-icon' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('use', { href: '#filter', xlinkHref: '#filter' })
            )
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { 'class': 'c-shop-overview__filter-container' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_4__Filter__["a" /* default */], {
            posts: this.state.posts,
            allPosts: this.state.allPosts,
            allCategories: this.state.allCategories,
            allWidths: this.state.allWidths,
            allColors: this.state.allColors,
            currentCategories: this.state.currentCategories,
            currentWidths: this.state.currentWidths,
            currentColors: this.state.currentColors,
            order: this.state.order,
            handleChange: this.handleChange.bind(this),
            filterActive: this.state.filterActive,
            handleToggle: this.handleToggle.bind(this),
            isLoading: this.state.isLoading,
            handleRemove: this.handleRemove.bind(this),
            handleReset: this.handleReset.bind(this),
            handleOrder: this.handleOrderChoice.bind(this)
          })
        ),
        this.state.isLoading ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_5__components_Loader__["a" /* default */], null) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { 'class': 'c-shop-overview__posts-wrapper' },
          this.state.posts.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { 'class': 'c-shop-overview__fragment-wrapper' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'div',
              { 'class': 'c-shop-overview__posts-container' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__components_Posts__["a" /* default */], {
                posts: this.state.posts,
                allPosts: this.state.allPosts,
                loading: this.state.isLoading,
                handleOrderChoice: this.handleOrderChoice.bind(this)
              }),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_6__components_Pagination__["a" /* default */], {
                count: this.state.count,
                offset: this.state.offset,
                currentPage: this.state.currentPage,
                totalAmountPosts: this.state.allPosts.length,
                handlePageClick: this.handlePageClick.bind(this)
              })
            )
          ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { className: 'c-shop-overview__no-posts' },
            'Geen resultaten',
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'div',
              { className: 'c-shop-overview__reset', onClick: function onClick() {
                  _this4.handleReset();
                } },
              'Reset filters'
            )
          )
        )
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductsAPI = function () {
  function ProductsAPI() {
    _classCallCheck(this, ProductsAPI);
  }

  _createClass(ProductsAPI, null, [{
    key: 'all',
    value: function all(state) {
      var url = this.getUrl(state);

      return fetch(url, {
        credentials: 'same-origin'
      }).then(this.handleStatus);
    }
  }, {
    key: 'handleStatus',
    value: function handleStatus(response) {
      if (!response.ok) {
        // Fetch doesn't reject on HTTP error status
        throw Error('Request rejected with status ' + response.status);
      }
      return response;
    }
  }, {
    key: 'getUrl',
    value: function getUrl(params) {
      var currentCategories = params.currentCategories,
          currentColors = params.currentColors,
          currentWidths = params.currentWidths,
          order = params.order,
          count = params.count,
          offset = params.offset;


      var orderby = this.orderQuery(order);

      var filterCategories = currentCategories.length > 0 ? '&vorm=' + currentCategories : '';
      var filterColors = currentColors.length > 0 ? '&kleur=' + currentColors : '';
      var filterWidths = currentWidths.length > 0 ? '&dikte=' + currentWidths : '';

      var query = filterCategories + filterColors + filterWidths;
      var countQuery = 'per_page=' + count;

      return '/wp-json/wp/v2/product?' + countQuery + orderby + query;
    }
  }, {
    key: 'orderQuery',
    value: function orderQuery(order) {
      if (order === 'price_desc') {
        return '?orderby=price&order=desc';
      } else if (order === 'price_asc') {
        return '?orderby=price&order=asc';
      } else {
        return '';
      }
    }
  }]);

  return ProductsAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProductsAPI);

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableAPI = function () {
  function TableAPI() {
    _classCallCheck(this, TableAPI);
  }

  _createClass(TableAPI, null, [{
    key: 'all',
    value: function all() {
      // let url = '/wp-json/mattador/v1/all_products'
      var url = '/wp-json/wp/v2/product?per_page=100';

      return fetch(url, {
        credentials: 'same-origin'
      }).then(this.handleStatus);
    }
  }, {
    key: 'handleStatus',
    value: function handleStatus(response) {
      if (!response.ok) {
        // Fetch doesn't reject on HTTP error status
        throw Error('Request rejected with status ' + response.status);
      }
      return response;
    }
  }]);

  return TableAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (TableAPI);

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Post__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loader__ = __webpack_require__(33);




// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Posts = function Posts(props) {
  var posts = props.posts;

  var activeClass = props.showAll ? 'active' : '';

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-shop-overview__posts u-flex' },
    posts.map(function (post, index) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__Post__["a" /* default */], { key: post.id, post: post });
    }),
    props.loading ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__Loader__["a" /* default */], null) : null
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Posts);

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Post = function Post(props) {
  var post = props.post;


  var fullTitle = post.title.rendered.split('&#8211;');
  var title = fullTitle[0];
  var subtitle = fullTitle[1];
  var image = post.featured_image_link;
  var secondImage = post.second_featured_image_link;
  var price = post.price ? post.price : false;
  var url = post.link;
  var thickness = post.product_thickness ? post.product_thickness : false;
  var color = post.product_color ? post.product_color : false;
  var shape = post.product_shape ? post.product_shape : false;
  var reviewRating = post.product_rating ? post.product_rating : 0;
  var reviewComments = post.product_reviews ? post.product_reviews : 0;
  var reviewRatingRounded = post.product_rating !== 0 ? Math.round(post.product_rating) : 0;
  var stars = [];

  console.log(post);

  // Append all the filled whole stars
  for (var i = reviewRatingRounded; i >= 1; i--) {
    stars.push('<svg class="c-icon  c-usps__icon"><use href="#star-full"></use></svg>');
    if (i == .5) stars.push('<svg class="c-icon  c-usps__icon"><use href="#star-half"></use></svg>');
  }

  // Fill the empty stars
  for (var _i = 5 - reviewRatingRounded; _i >= 1; _i--) {
    stars.push('<svg class="c-icon  c-usps__icon"><use href="#star-empty"></use></svg>');
  }return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-shop-overview__post c-shop-item' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-shop-item__image-wrapper' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'a',
        { href: url, className: 'c-shop-item__image-container u-image' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('img', { src: image, className: 'c-shop-item__image u-image__background', alt: title }),
        secondImage ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('img', { src: secondImage, className: 'c-shop-item__image c-shop-item__image--background u-image__background', alt: title }) : null
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-shop-item__header' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'h3',
        { className: 'c-shop-item__title' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'a',
          { href: url, className: 'c-shop-item__product-link' },
          title
        )
      ),
      subtitle ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-shop-item__subtitle' },
        subtitle
      ) : null
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-shop-item__body u-flex' },
      color ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-shop-item__attribute' },
        color
      ) : null,
      thickness ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-shop-item__attribute' },
        thickness,
        ' mm'
      ) : null,
      shape ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-shop-item__attribute' },
        shape
      ) : null
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-shop-item__footer u-flex u-flex-sb' },
      post.product_rating !== '0' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-shop-item__rating u-flex' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-shop-item__stars u-flex' },
          stars.map(function (star) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', { className: 'c-shop-item__star', dangerouslySetInnerHTML: { __html: star } });
          })
        ),
        reviewComments,
        ' reviews'
      ) : null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-shop-item__price-container u-flex u-flex-v-center' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-shop-item__price-tag' },
          'Vanaf'
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-shop-item__price' },
          price
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Post);

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkboxes__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Filters__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Orderby__ = __webpack_require__(168);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Filter = function (_Component) {
  _inherits(Filter, _Component);

  function Filter(props) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

    _this.state = {
      error: false,
      isLoading: false
    };
    return _this;
  }

  _createClass(Filter, [{
    key: 'render',
    value: function render() {
      var filterActive = this.props.filterActive;

      var activeClass = filterActive ? 'active' : '';

      var resultsNumber = this.props.allPosts.length > 0 ? this.props.allPosts.length : this.props.posts.length;

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-shop-filter ' + activeClass },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-shop-filter__filter-wrapper' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { className: 'c-shop-filter__wrapper' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'div',
              { className: 'c-shop-filter__top-bar u-hide-on-large-up' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
                'div',
                { className: 'c-shop-filter__top-bar-title' },
                'Filteren'
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
                'svg',
                { className: 'c-icon c-shop-filter__filter-icon', onClick: this.props.handleToggle },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('use', { href: '#close', xlinkHref: '#close' })
              )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'div',
              { 'class': 'c-shop-overview__count u-flex u-hide-on-medium-down' },
              resultsNumber,
              ' resultaten'
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__components_Orderby__["a" /* default */], {
              order: this.props.order,
              onSelectOrder: this.props.handleOrder,
              postsLoading: this.props.loading,
              handleChange: this.props.handleChange,
              isLoading: this.props.isLoading
            }),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__Checkboxes__["a" /* default */], {
              handleChange: this.props.handleChange,
              handleClick: this.props.handleClick,
              target: 'currentCategories',
              items: this.props.allCategories,
              currentElements: this.props.currentCategories,
              type: 'categories',
              title: 'Categorie',
              isLoading: this.props.isLoading,
              allPosts: this.props.allPosts
            }),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__Checkboxes__["a" /* default */], {
              handleChange: this.props.handleChange,
              handleClick: this.props.handleClick,
              target: 'currentWidths',
              items: this.props.allWidths,
              currentElements: this.props.currentWidths,
              type: 'widths',
              title: 'Matdikte',
              isLoading: this.props.isLoading,
              allPosts: this.props.allPosts
            }),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__Checkboxes__["a" /* default */], {
              handleChange: this.props.handleChange,
              handleClick: this.props.handleClick,
              target: 'currentColors',
              items: this.props.allColors,
              currentElements: this.props.currentColors,
              type: 'colors',
              title: 'Kleur',
              isLoading: this.props.isLoading,
              allPosts: this.props.allPosts
            })
          )
        )
      );
    }
  }]);

  return Filter;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (Filter);

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Checkboxes = function (_Component) {
  _inherits(Checkboxes, _Component);

  function Checkboxes(props) {
    _classCallCheck(this, Checkboxes);

    var _this = _possibleConstructorReturn(this, (Checkboxes.__proto__ || Object.getPrototypeOf(Checkboxes)).call(this, props));

    _this.state = {
      collapsed: false
    };
    return _this;
  }

  _createClass(Checkboxes, [{
    key: 'handleDropdown',
    value: function handleDropdown(e) {
      var container = e.currentTarget.closest('.js-target-click');
      container.classList.toggle('activated');
    }
  }, {
    key: 'handleOptions',
    value: function handleOptions(e) {
      this.state.collapsed ? this.setState({ collapsed: false }) : this.setState({ collapsed: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-shop-filter__checkboxes' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-shop-filter__title js-target-trigger', onClick: this.handleDropdown.bind(this) },
          this.props.title
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-shop-filter__options' },
          this.props.items.map(function (item, index) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'div',
              { className: 'c-shop-filter__checkbox' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', {
                type: 'checkbox',
                name: item,
                value: '1',
                checked: _this2.props.currentElements.includes(item),
                id: item,
                className: 'c-shop-filter__input',
                onClick: _this2.props.handleChange,
                'data-target': _this2.props.target,
                'data-id': item,
                disabled: _this2.props.isLoading
              }),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
                'label',
                { className: 'c-shop-filter__label', 'for': item },
                item
              )
            );
          }),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { className: 'c-shop-filter__view-results u-hide-on-medium-up' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'div',
              { className: 'c-shop-filter__results-button', onClick: this.props.handleClose },
              'View results',
              ' ',
              this.props.allPosts.length ? '(' + this.props.allPosts.length + ')' : null
            )
          )
        )
      );
    }
  }]);

  return Checkboxes;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (Checkboxes);

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Filters = function Filters(props) {
  var activeClass = props.currentWidths.length > 0 || props.currentColors.length > 0 || props.currentCategories.length > 0 ? 'c-shop-filters c-shop-filters--active' : 'c-shop-filters';
  var allWidths = props.allWidths;
  var allCategories = props.allCategories;
  var allColors = props.allColors;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: activeClass },
    activeClass === 'c-shop-filters c-shop-filters--active' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-shop-filters__container' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-shop-filters__item c-shop-filters__item--close', onClick: props.handleReset },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { 'class': 'c-shop-filters__item-content' },
          'Clear all filters'
        )
      ),
      props.currentWidths.map(function (item) {
        if (props.currentWidths.length > 1) {
          var currentCategory = allWidths.filter(function (category) {
            return category.id == item;
          });
          var currentCategoryName = currentCategory.length >= 1 ? currentCategory[0].name : currentCategory;
          var currentCategoryID = currentCategory.length >= 1 ? currentCategory[0].id : currentCategory;
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(Item, { handleRemove: props.handleRemove, target: 'currentWidths', item: currentCategoryName, id: currentCategoryID });
        }
      }),
      props.currentColors.map(function (item) {
        if (props.currentColors.length > 1) {
          var currentCategory = allColors.filter(function (category) {
            return category.id == item;
          });
          var currentCategoryName = currentCategory.length >= 1 ? currentCategory[0].name : currentCategory;
          var currentCategoryID = currentCategory.length >= 1 ? currentCategory[0].id : currentCategory;
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(Item, { handleRemove: props.handleRemove, target: 'currentColors', item: currentCategoryName, id: currentCategoryID });
        }
      }),
      props.currentCategories.map(function (item) {
        if (props.currentCategories.length > 1) {
          var currentCategory = allCategories.filter(function (category) {
            return category.id == item;
          });
          var currentCategoryName = currentCategory.length >= 1 ? currentCategory[0].name : currentCategory;
          var currentCategoryID = currentCategory.length >= 1 ? currentCategory[0].id : currentCategory;
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(Item, { handleRemove: props.handleRemove, target: 'currentCategories', item: currentCategoryName, id: currentCategoryID });
        }
      })
    ) : null
  );
};

var Item = function Item(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-shop-filters__item', onClick: props.handleRemove, 'data-target': props.target, 'data-name': props.item, 'data-id': props.id },
    props.label ? props.label : props.item,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'svg',
      { className: 'c-icon c-shop-filters__icon' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('use', { href: '#close', xlinkHref: '#close' })
    )
  );
};

/* unused harmony default export */ var _unused_webpack_default_export = (Filters);

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var OrderBy = function OrderBy(props) {
  function handleOrderChoice(e) {
    props.onSelectOrder(e.target.value);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    "div",
    { className: "c-shop-select-filter" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      "div",
      { className: "c-shop-select-filter__title" },
      "Sorteren"
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      "div",
      { className: "c-shop-select-filter__option" },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("input", {
        type: "checkbox",
        name: "price_asc",
        value: "1",
        id: "price_asc",
        className: "c-shop-filter__input",
        onClick: props.onSelectOrder,
        "data-target": "order",
        "data-id": "price_asc",
        disabled: props.isLoading
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        "label",
        { className: "c-shop-filter__label c-shop-select-filter__label", "for": "price_asc" },
        "Prijs laag-hoog"
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      "div",
      { className: "c-shop-select-filter__option" },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("input", {
        type: "checkbox",
        name: "price_desc",
        value: "1",
        id: "price_desc",
        className: "c-shop-filter__input",
        onClick: props.onSelectOrder,
        "data-target": "order",
        "data-id": "price_desc",
        disabled: props.isLoading
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        "label",
        { className: "c-shop-filter__label c-shop-select-filter__label", "for": "price_desc" },
        "Prijs hoog-laag"
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (OrderBy);

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Pagination = function Pagination(props) {
  var pages = [];
  var length = Math.ceil(props.totalAmountPosts / props.count + 1);

  for (var i = 1; i < length; i++) {
    pages.push(i);
  }

  if (pages.length > 1) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      "div",
      { className: "c-shop-pagination" },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        "div",
        { className: "c-shop-pagination__container" },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(Pages, {
          pages: pages,
          currentPage: props.currentPage,
          handlePageClick: props.handlePageClick
        })
      )
    );
  }
};

var Pages = function Pages(props) {
  var max = props.currentPage == 1 ? 3 : Number(props.currentPage) + 1;
  var min = props.currentPage == props.pages.length ? props.pages.length - 3 : Number(props.currentPage) - 2;

  // Function to check what pages should show in the pagination
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    "div",
    { "class": "c-shop-overview__fragment-wrapper" },
    props.currentPage > 2 && props.pages.length > 3 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      "div",
      { "class": "c-shop-overview__fragment-wrapper" },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        "div",
        {
          "data-page": Number(props.currentPage - 1),
          className: "c-shop-pagination__button c-shop-pagination__button--prev",
          onClick: props.handlePageClick
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          "svg",
          { className: "c-icon c-shop-pagination__icon" },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("use", { href: "#chevron-right", xlinkHref: "#chevron-right" })
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(Page, {
        handlePageClick: props.handlePageClick,
        page: props.pages[0],
        currentPage: props.currentPage
      })
    ) : null,
    props.pages.map(function (page, index) {
      if (index < max && index + 1 > min) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(Page, {
          handlePageClick: props.handlePageClick,
          page: page,
          currentPage: props.currentPage
        });
      }
    }),
    props.currentPage < props.pages.length - 1 && props.pages.length > 3 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      "div",
      { "class": "c-shop-overview__fragment-wrapper" },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(Page, {
        handlePageClick: props.handlePageClick,
        page: props.pages[props.pages.length - 1],
        currentPage: props.currentPage
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        "div",
        {
          "data-page": props.currentPage + 1,
          className: "c-shop-pagination__button c-shop-pagination__button--next",
          onClick: props.handlePageClick
        },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          "svg",
          { className: "c-icon c-shop-pagination__icon" },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("use", { href: "#chevron-right", xlinkHref: "#chevron-right" })
        )
      )
    ) : null
  );
};

var Page = function Page(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    "div",
    {
      onClick: props.handlePageClick,
      className: "c-shop-pagination__page " + (props.currentPage == props.page ? 'active' : ''),
      "data-page": props.page,
      key: props.page
    },
    props.page
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Loader = function Loader() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    "div",
    { className: "c-shop-loader" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect1" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect2" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect3" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect4" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect5" })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e,t){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)t(exports);else{var o={};t(o),e.bodyScrollLock=o}}(this,function(exports){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}Object.defineProperty(exports,"__esModule",{value:!0});var l=!1;if("undefined"!=typeof window){var e={get passive(){l=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}var d="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&/iP(ad|hone|od)/.test(window.navigator.platform),c=[],u=!1,a=-1,s=void 0,v=void 0,f=function(t){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(t))})},m=function(e){var t=e||window.event;return!!f(t.target)||(1<t.touches.length||(t.preventDefault&&t.preventDefault(),!1))},o=function(){setTimeout(function(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)})};exports.disableBodyScroll=function(i,e){if(d){if(!i)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(i&&!c.some(function(e){return e.targetElement===i})){var t={targetElement:i,options:e||{}};c=[].concat(r(c),[t]),i.ontouchstart=function(e){1===e.targetTouches.length&&(a=e.targetTouches[0].clientY)},i.ontouchmove=function(e){var t,o,n,r;1===e.targetTouches.length&&(o=i,r=(t=e).targetTouches[0].clientY-a,!f(t.target)&&(o&&0===o.scrollTop&&0<r?m(t):(n=o)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&r<0?m(t):t.stopPropagation()))},u||(document.addEventListener("touchmove",m,l?{passive:!1}:void 0),u=!0)}}else{n=e,setTimeout(function(){if(void 0===v){var e=!!n&&!0===n.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;e&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")});var o={targetElement:i,options:e||{}};c=[].concat(r(c),[o])}var n},exports.clearAllBodyScrollLocks=function(){d?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),u&&(document.removeEventListener("touchmove",m,l?{passive:!1}:void 0),u=!1),c=[],a=-1):(o(),c=[])},exports.enableBodyScroll=function(t){if(d){if(!t)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");t.ontouchstart=null,t.ontouchmove=null,c=c.filter(function(e){return e.targetElement!==t}),u&&0===c.length&&(document.removeEventListener("touchmove",m,l?{passive:!1}:void 0),u=!1)}else 1===c.length&&c[0].targetElement===t?(o(),c=[]):c=c.filter(function(e){return e.targetElement!==t})}});


/***/ })

},[159]);


// WEBPACK FOOTER //
// shop.86e76a15aa59198e0d7d.js